<!--
* 组件名 : 图片墙绘画卡片
* 开发者 : JY
*
* 参数:
*  image     { String }   required - 阶段缩略图
*  title     { String }   required - 阶段标题
*  paint     { String }   required - 原始手绘图
*
* 事件:
*   on_click  [index] - 打开图片查看器  index 当前图片下标
*
-->
<template>
  <div class="picture-wall-card" ref="wrap">
    <div class="card-item">
      <div
        class="img-border"
        v-bg-img="!perpendicular ? borderImage : border2Image"
      />

      <div class="img-canvas" ref="imgCanvas">
        <div class="current-paint" v-bg-img="image" :data-slug="slug" />
        <v-btn class="picture-view-btn" @btnClick="on_click">
          <v-icon>zoom_in</v-icon>
        </v-btn>
      </div>
    </div>
    <div class="desc-content">
      <div class="paint-nano" ref="paintNano">
        <div class="desc scrollbar" v-html="title"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { i18n, renderImage, timeout } from "utils/util";
export default {
  name: "picture-wall-card",

  props: {
    image: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    paint: {
      type: String,
      required: true,
    },
    slug: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      borderImage:
        "images/Son-of-man-begins-speaking-in-house-churches/border.png",
      border2Image:
        "images/Son-of-man-begins-speaking-in-house-churches/border2.png",
      perpendicular: false,
      imgUrl: i18n(this.image),
    };
  },

  created() {
    this.on_image_load(this.imgUrl);
  },
  methods: {
    on_image_load(image) {
      renderImage(image).then((size) => {
        //  判断竖版手绘图
        if (size.height / size.width > 0.8) {
          $(this.$refs.wrap).addClass("perpendicular");
          this.perpendicular = true;
          this.$emit("update");
        }
      });
    },
    /**
     *  打开图片查看器
     */
    on_click() {
      this.$emit("itemClick", this.index);
    },
  },
};
</script>

<style lang="scss">
.picture-wall-card {
  margin-right: 160px;
  width: 704px;
  height: 100%;
  @include flex(center, center, null, column);

  .card-item {
    width: 100%;
    height: 528px;
    position: relative;
    padding: 66px 70px;

    &::after {
      content: "";
      position: absolute;
      top: 4px;
      bottom: 4px;
      left: 4px;
      right: 4px;
      display: block;
      box-shadow: 6px 20px 30px 0 rgb(0 0 0 / 50%);
    }
  }

  .img-border {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    background-size: contain;
    background-repeat: no-repeat;
  }

  .picture-view-btn {
    position: absolute;
    bottom: 24px;
    right: 24px;
    z-index: 20;
    opacity: 0;
    transition: opacity 0.35s ease;
  }

  .img-canvas {
    height: 100%;
    position: relative;

    &:hover {
      .picture-view-btn {
        opacity: 1;
      }
    }

    .current-paint {
      background-size: cover;
      background-position: 50%;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      margin: auto;
      z-index: 1;
      width: 100%;
    }
  }

  .desc-content {
    width: 100%;
    margin-top: 32px;
    padding: 0 12px 32px 20px;

    .paint-nano {
      height: calc(4 * 1.5em);
      @include flex(null, center);
    }

    .desc {
      overflow-y: auto;
      padding-right: 10px;

      p {
        margin-bottom: 8px;
      }
    }
  }

  &.perpendicular {
    margin-top: -30px;
    width: 440px;

    .card-item {
      width: 100%;
      height: 587px;
      padding: 59px 56px;
    }

    .img-canvas {
      height: 100%;
      overflow: hidden;
    }
  }

  @media (max-width: $lx-max) {
    width: 614px;
    margin-right: 146px;

    &.perpendicular {
      width: 383px;

      .card-item {
        height: 512px;
        padding: 52px 49px;
      }
    }

    .card-item {
      height: 460px;
      padding: 58px 62px;
    }
  }

  @media (max-width: $lx-min) {
    margin-right: 120px;
    width: 475px;

    &.perpendicular {
      width: 296px;

      .card-item {
        height: 395px;
        padding: 36px 28px;
      }
    }

    .card-item {
      height: 356px;
      padding: 40px 46px;
    }
  }
}
</style>
